import { useRef, useState } from "react";
import { itx } from "../translationItx/itx";

export function AppHeaderProjectName({ name, onChange, idPrefix }: {
  name: string;
  onChange?: (name: string) => void;
  idPrefix: string;
}) {
  const [draft, setDraft] = useState<string | null>(null);
  const finished = useRef(false);
  const button = useRef<HTMLButtonElement>(null);
  const label = itx("mainAppHeader.editProjectName", "Projektname bearbeiten");

  function finish(save: boolean, restoreFocus = false) {
    if (finished.current) return;
    finished.current = true;
    const nextName = draft?.trim();
    if (save && nextName && nextName !== name) onChange?.(nextName);
    setDraft(null);
    if (restoreFocus) requestAnimationFrame(() => button.current?.focus());
  }

  if (draft !== null) return (
    <input
      className="mainAppHeaderProject mainAppHeaderProjectInput"
      data-testid={`${idPrefix}-project-name-input`}
      aria-label={label}
      value={draft}
      autoFocus
      onFocus={event => event.currentTarget.select()}
      onChange={event => setDraft(event.target.value)}
      onBlur={() => finish(true)}
      onKeyDown={event => {
        event.stopPropagation();
        if (event.nativeEvent.isComposing) return;
        if (event.key === "Enter" || event.key === "Escape") {
          event.preventDefault();
          finish(event.key === "Enter", true);
        }
      }}
    />
  );

  if (!onChange) return <span className="mainAppHeaderProject" title={name}>{name}</span>;

  return (
    <button
      ref={button}
      type="button"
      className="mainAppHeaderProject mainAppHeaderProjectButton"
      data-testid={`${idPrefix}-project-name`}
      title={label}
      aria-label={`${label}: ${name}`}
      onClick={() => { finished.current = false; setDraft(name); }}
    >
      {name || label}
    </button>
  );
}
